import {PredefinedEventHandlerTypeA} from "./predefinedEvent";
import {submitRequests} from "./actionEvent";
import {UIFlowEventHandlerTypeA,UIFlowEventHandlerTypeB} from "./uiFlowEvent";
import {getEventHandlerArgs as getSwitchFlowArgs} from "../props-utils";
import { BaseUIComponentProps } from "../../components/metadata-components/BaseUIComponent";

const DummyEventHandler = async () => {};

export function generateEventFunctions(eventHandlers:string[], eventName:string, 
                                       props:BaseUIComponentProps) {
//   console.debug(`genereate event ${eventName} handlers ${JSON.stringify(eventHandlers)} componentId=${props.metadata.componentId}`,
//                 `viewNames`,props.formBean.ViewMetadataList.map((v) => v.name), 
//                 `UIFlowEventHandlerTypeA`,Object.keys(UIFlowEventHandlerTypeA),
//                 `UIFlowEventHandlerTypeB`,Object.keys(UIFlowEventHandlerTypeB),
//                 `PredefinedEventHandlerTypeA`,Object.keys(PredefinedEventHandlerTypeA),
//                 )                                           
  if (!eventHandlers || eventHandlers.length<1) return;
  
  let {formBean} = props;
  const ctx = props.ctx!;
  let result = [] as Function[];
  let viewNames = formBean.ViewMetadataList.map((v) => v.name);

  for(let eventHandler of eventHandlers) {
    if (!eventHandler) continue;
    let eventFn = DummyEventHandler; // dummy do-nothing function

    eventHandler = eventHandler.replace(' ', '');
    if (eventHandler.startsWith("action")){ // does UI designer checks actions can be packed together???
        // e.g action.PaymentFacade.validateAccountInfo,action.PaymentFacade.submitPayment,
        let parts = eventHandler.split(',').filter(x=>!!x);
        for(let s of parts){
            if(!s.startsWith('action.')){
                console.error(`expect event handler ${s} in ${eventHandler} starts with action.`)
            }
        }
      let actions = parts.map(a => a.replace("action.", ""));

      eventFn = async () => submitRequests(formBean, actions);
    } else if(eventHandler.startsWith("UIFlow")){
        // e.g UIFlow.nextView, UIFlow.navigate.<view-name>
      let parts = eventHandler.split('.');

      if(parts.length == 3){
        let viewName = parts[2];
        let flowHandlerName = parts[1];
        if (typeof UIFlowEventHandlerTypeA[flowHandlerName] === "function"){
          eventFn = async () => UIFlowEventHandlerTypeA[flowHandlerName](formBean, viewName, viewNames);
        }else{
            console.warn(`missing UIFlow handler ${flowHandlerName} componentId=${props.metadata.componentId}`)
        }
      }
      else if (parts.length == 2){
        let flowHandlerName = parts[1];
        if (typeof UIFlowEventHandlerTypeB[flowHandlerName] === "function"){
          eventFn = async () => UIFlowEventHandlerTypeB[flowHandlerName](formBean, viewNames);
        }else{
            console.warn(`missing UIFlow handler ${flowHandlerName} componentId=${props.metadata.componentId}`)
        }
      }else{
        console.warn(`incomplete UIFlow handler ${eventHandler} componentId=${props.metadata.componentId}`)
      }
    } else if(eventHandler.startsWith("switchFlow")){
      eventHandler = eventHandler.trim();
      // get everything between parenthesis, 
      // e.g eventHandler == switchFlow(cp-payment,PaymentFacade.customerPaymentInit)
      // e.g witchFlow(<flow-name>,parm1=value1,parm2=value2) (deadcode)
      let parts = getSwitchFlowArgs(eventHandler);
      let newFlowName = parts[0];
      let action = parts[1];

      eventFn = async () => formBean.switchFlow(newFlowName, action);
    } else if(eventHandler.startsWith("previousFlow")){
      eventHandler = eventHandler.trim();
      //get everything between parenthesis, e.g eventHandler == previousFlow(PaymentFacade.customerPaymentInit)
      let parts = getSwitchFlowArgs(eventHandler);
      let action = parts.length > 0 ? parts[0] : null;

      eventFn = async () => formBean.previousFlow(action);
    } else {
      if (typeof PredefinedEventHandlerTypeA[eventHandler] === "function"){
          // eventFn = async ()=> validateUI(props);
        eventFn = async () =>{ PredefinedEventHandlerTypeA[eventHandler](props)};
      }else{
        console.warn(`missing predefined handler ${eventHandler} componentId=${props.metadata.componentId}`)
      }
    }
    if (eventFn !== DummyEventHandler) result.push(eventFn);
  }
  return result;
}